import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import {EuiFlexGroup, EuiFilePicker, EuiSpacer, EuiFlexItem, EuiFormRow, EuiPanel, EuiFieldNumber, EuiSwitch, EuiButtonIcon, EuiTitle, 
  EuiLoadingSpinner, EuiIcon, EuiRadioGroup,EuiFilterGroup,EuiFilterButton} from '@elastic/eui';
import moment from 'moment';
// import { Menu } from '../../../../components/Menus';
import { GridResultsScreen } from '../../../../components/GridInformes/GridResultsScreen';
import { SumarigramaContainer } from '../../../Consultas/Sumarigrama/Screen';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoPeriodoAbierto/container';
import './styles.css';
// import { info } from 'node:console';
import { useUserSettings } from "../../../../context/CurrentUserContext";
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';

interface dataRequest { IdCentroDesde: string, IdTipo: string }
interface dataDescargaRequest { IdCentroDesde: string, IdTipoContenido: string }

interface Props {
  onFilter(data: dataRequest): void;
  data: any;
  año: any;
  periodo: any;
  reunion: any;
  isLoading: boolean;
  onDataChange(filterData: any, data: any): void;
  onDescargar(reqData: any): void;
}

export const InformacionSubidaScreen = (props: Props) => {

  const { currentUser } = useUserSettings();

  let { onFilter, data, año, periodo, reunion, isLoading, onDataChange, onDescargar } = props;
  let [toogle, setToogle] = useState(false);
  const ref:any = useRef();
  
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  const _tiposMoneda = [{label:'Moneda Corriente',value:'MCR'}, {label:'Moneda Constante',value:'MCT'}]

  let [sinAño, setSinAño] = useState<boolean>(true);
  let [idCentro, setIdCentro] = useState<any>(undefined);
  let [idTipoContenido, setIdTipoContenido] = useState<any>(undefined);

  useEffect(()=>{
    setSinAño(año === undefined);
  },[año]);

  const onClickToogle = () =>{
    setToogle(!toogle)
  }

  const onChange = (value: any) => {
    setIdTipoContenido(value);
  }

  const onRefresh = () =>{
    onFilter(getRequesData());
  }

  const getRequesData = () => {
    const reqdata : dataRequest = {
      IdCentroDesde: idCentro, IdTipo: idTipoContenido
    }
    return (
      reqdata
    )
  }

  const getDescargaRequesData = () => {
    const reqdata : dataDescargaRequest = {
      IdCentroDesde: idCentro, IdTipoContenido: idTipoContenido
    }
    return (
      reqdata
    )
  }

  const getFilter = useMemo(()=> {return{'año':año, 'periodo':periodo, 'idTipoContenido':'INFSUB'}},[año,periodo])

  const onClickCentro = (id:string)=> setIdCentro(id)

  const fnIsLoading = (pisLoading: boolean, psinAño: boolean) =>{
    if(pisLoading)
      return <EuiLoadingSpinner size="xl" />
    else
      return <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()} isDisabled={psinAño} />
  }

  
  const getIdCentro = useMemo(()=> idCentro,[idCentro]);

  const getNombreCentro = () => {
    let dataFilter=[];

    dataFilter = (data && data.filter((d:any)=> d.idCentro === idCentro))

    if(dataFilter.length>0){return dataFilter[0].centro}else{return ''}
  }

  const centro = useMemo(()=> data && data[0] ?  `${idCentro} - ${getNombreCentro()}` : '',[data])

  const onRowDataChanged = (rows: any)  => {
    console.log('rowDataChanged ', rows);
    onDataChange(getRequesData(), rows);
  }

  const onDescargarFichero = async() =>{
    onDescargar(getDescargaRequesData());
  }

  const Actions: Action[] = useMemo(()=>[
    {handle:onDescargarFichero,text:"Descargar",color:"secondary",size:"s", isDisabled: false}
  ],[idTipoContenido, idCentro]);

  // const Actions: Action[] = useMemo(()=>[
  //   {handle:onExport,text:"Exportar",size:"s", isDisabled:!showGrid},
  //   {handle:onClickPrint, text:"Imprimir", size: "s", isDisabled: data.length == 0 || showGrid},
  //   {handle:onImageDownload, text:"Descargar Imagen", size: "s", isDisabled: data.length == 0 || showGrid}
  // ],[onExport, onClickPrint, onImageDownload, showGrid, data])


  return(
    <>
    <EuiFlexGroup gutterSize='none' style={{height:'100%'}} className={(toogle ? "collapsePanel collapsed" : "collapsePanel")}>
      <EuiFlexItem grow={false}>
        <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
            <EuiFlexItem grow={false}>
              <SelectorTiposContenido valueOfSelected={idTipoContenido} onChange={(value: any) => onChange(value)} />
            </EuiFlexItem>
            <EuiFlexItem style={{overflow:'hidden'}}>
                <SumarigramaContainer menu={true} onlySearch={true} filter={getFilter} onClickNode={onClickCentro} style={{overflow:'auto',height: '100%', border:'none'}}/>
            </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem className='tooglebtn' grow={false} onClick={onClickToogle}>
        <EuiIcon type={toogle ? "arrowRight" : "arrowLeft"} size="l" onClick={onClickToogle}/>
      </EuiFlexItem>
      <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
        <EuiFlexGroup alignItems='baseline'>
          <EuiFlexItem>
            <EuiFlexGroup alignItems='center' >
              <EuiFlexItem></EuiFlexItem>
              <EuiFlexItem grow={false} style={{marginLeft:'2rem'}}>
                {fnIsLoading(isLoading, sinAño)}
              </EuiFlexItem>
              <EuiFlexItem>
                {<Menu actions={Actions} className="actions"/>}
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
       
          <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
            <EuiFlexItem style={{ overflowX:'auto', overflowY:'auto'}}>
            <GridResultsScreen
              data={data}
              selector={false}
              menu={false}
              ref={ref}
              informe={'INFSUB'}
              onChange={onRowDataChanged}
            />
            </EuiFlexItem>
          </EuiFlexGroup> 
        </EuiFlexItem>
        </EuiFlexGroup>
  </>
  )

  // return (
  //   <>
  //     <EuiFlexGroup style={{height:'100%'}} className={(toogle ? "collapsePanel collapsed" : "collapsePanel")}>
  //           <EuiFlexItem>
  //               <EuiFormRow>
  //                 <EuiTitle size="s"><h1>{(año !== undefined ? año + ' - ' + reunion : "No hay ningun periodo abierto.")}</h1></EuiTitle>
  //               </EuiFormRow>
  //               <EuiFormRow>
  //                 <SelectorTiposContenido valueOfSelected={idTipoContenido} onChange={(value: any) => onChange(value)} />
  //               </EuiFormRow>
  //               <EuiFormRow style={{overflow:'auto', border:'none'}}>
  //                 <SumarigramaContainer menu={false} filter={getFilter} onClickNode={onClickCentro} style={{overflow:'auto',height: '100%', border:'none'}}/>
  //               </EuiFormRow>
  //           </EuiFlexItem>
  //           <EuiFlexItem className='tooglebtn' grow={false} onClick={onClickToogle}>
  //             <EuiIcon type={toogle ? "arrowRight" : "arrowLeft"} size="l" onClick={onClickToogle}/>
  //           </EuiFlexItem>
  //       <EuiFlexItem style={{height: "100%",padding: "0.2rem", overflow:"hidden", marginBottom:'5px'}}>
  //         <EuiFlexGroup alignItems='baseline'>
  //           <EuiFlexItem style={{flexGrow:0.3}}>
  //             {/* <SelectorMonedas selectedOptions={moneda} onChange={(value:any) => setMoneda(value)}/>  */}
  //           </EuiFlexItem>
  //           <EuiFlexItem>
  //           <EuiFlexGroup alignItems='center' >
  //             <EuiFlexItem grow={false}>
  //             <EuiFilterGroup>
  //               {/* <EuiFilterButton
  //                 grow={false}
  //                 hasActiveFilters={tipoCambioMoneda===_tiposMoneda[0].value}
  //                 onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[0].value)}>
  //                 {_tiposMoneda[0].label}
  //               </EuiFilterButton>
  //               <EuiFilterButton
  //                 grow={false}
  //                 hasActiveFilters={tipoCambioMoneda===_tiposMoneda[1].value}
  //                 onClick={()=>onChangeTipoCambioMoneda(_tiposMoneda[1].value)}>
  //                   {_tiposMoneda[1].label}
  //               </EuiFilterButton> */}
  //             </EuiFilterGroup>
  //             </EuiFlexItem>
  //             <EuiFlexItem grow={false}>
  //               {fnIsLoading(isLoading, sinAño)}
  //             </EuiFlexItem>
  //             <EuiFlexItem>
  //               {<Menu actions={Actions} className="actions"/>}
  //               {/* <Menu actions={Actions}/> */}
  //             </EuiFlexItem>
  //           </EuiFlexGroup>
  //         </EuiFlexItem>
  //         </EuiFlexGroup>
  //           <EuiFlexGroup style={{height:'95%', flexDirection:'column'}}>
  //             {/* <EuiFlexItem grow={false} style={{marginBottom:'0'}}>
  //               <div className='titleReport'>{getTitle}</div>
  //             </EuiFlexItem> */}
  //             <EuiFlexItem style={{ overflowX:'auto', overflowY:'auto'}}>
  //               <GridResultsScreen
  //                 data={data}
  //                 selector={false}
  //                 menu={false}
  //                 ref={ref}
  //                 informe={'INFSUB'}
  //                 onChange={onRowDataChanged}
  //                 // onMostrarOcultarClick={(['DN_ADMON','IT','CG'].indexOf(currentUser.perfil) >= 0 ? onVerOcultarClick : undefined)}
  //                 // verBotonMostrarOcultar={['DN_ADMON','IT','CG'].indexOf(currentUser.perfil) >= 0}
  //                 // onSubirBajarClick={(['DN_ADMON','IT','CG'].indexOf(currentUser.perfil) >= 0 ? onSubirBajarNivelClick : undefined)}
  //                 // onOtroFormatoClick={(['DN_ADMON','IT','CG'].indexOf(currentUser.perfil) >= 0 ? onCentroOtroFormatoClick : undefined)}
  //               />
  //             </EuiFlexItem>
  //           </EuiFlexGroup> 
  //         </EuiFlexItem>
  //         </EuiFlexGroup>
  //   </>
  // );
};

export default InformacionSubidaScreen;
